/**
 * @fileoverview Hook for tracking window width and responding to resize events.
 * Provides the current viewport width and automatically updates when the window is resized.
 *
 * @example
 * // Get the current viewport width
 * const width = useResize();
 *
 * // Use width to make responsive UI decisions
 * return width > 768 ? <DesktopView /> : <MobileView />;
 */

import { useEffect, useState } from 'react'

/**
 * @function useResize
 * @description Hook for tracking window width and responding to resize events.
 * @returns {number} The current viewport width.
 */
export function useResize(): number {
    const [width, setWidth] = useState<number>(screen.width)
    useEffect(() => {
        function handleResize() {
            setWidth(document.documentElement.clientWidth)
        }

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    return width
}
